import { isFailure } from "@sportal/api";
import {
  getMarkedOptions,
  parseMarkdown,
} from "@sportal/lib/marked/parseMarkdown";

import { defaultLanguage } from "../../api/appConfigService";
import { getSelectedLanguage } from "../../i18n/language.selectors";

export const loadHelpContent =
  () =>
  async (dispatch, getState, { api }) => {
    dispatch({ type: LOAD_HELP });
    const state = getState();
    const language = getSelectedLanguage(state).key;
    const fallbackLanguage = defaultLanguage.key;

    const result = await api.helpContent.getHelpContent(
      language,
      fallbackLanguage
    );

    if (isFailure(result)) {
      return dispatch(loadHelpFailure(result.error));
    }

    const mdOptions = getMarkedOptions(language);
    const mdSections = parseMarkdown(result.data, mdOptions);

    dispatch(loadHelpSuccess(mdSections));
  };

export const LOAD_HELP = "[HELP] LOAD_HELP";
export const LOAD_HELP_SUCCESS = "[HELP] LOAD_HELP_SUCCESS";
export const loadHelpSuccess = (sections) => ({
  type: LOAD_HELP_SUCCESS,
  payload: sections,
});
export const LOAD_HELP_FAILURE = "[HELP] LOAD_HELP_FAILURE";
export const loadHelpFailure = (error) => ({
  type: LOAD_HELP_FAILURE,
  payload: error,
});
